export default __webpack_public_path__ + "static/media/graphic-17.42170051.png";